class StickyAtc extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.onScrollHandler = this.onScroll.bind(this);
    // window.addEventListener("scroll", this.onScrollHandler);
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    // threshold should be 0 which is default
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
            // check if element above the viewport
            const isUnderViewport = entry.boundingClientRect.top > window.innerHeight && entry.boundingClientRect.bottom > window.innerHeight;
            // Partially visible elements return true:
            const isVisible = entry.boundingClientRect.top < window.innerHeight && entry.boundingClientRect.bottom >= 0;
            if (isVisible || isUnderViewport) {
                requestAnimationFrame(this.hide.bind(this));
              } else {
                requestAnimationFrame(this.reveal.bind(this));
              }
        });
    });
    observer.observe(this.parentElement);
  }

//   onScroll() {
//     if (this.isScrolledIntoView()) {
//       requestAnimationFrame(this.hide.bind(this));
//     } else {
//       requestAnimationFrame(this.reveal.bind(this));
//     }
//   }
//   isScrolledIntoView() {

//     const rect = this.parentElement.getBoundingClientRect();
//     const elemTop = rect.top;
//     const elemBottom = rect.bottom;
//     // Only completely visible elements return true:
//     // const isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
//     // check if element under the viewport
//     const isUnderViewport = elemTop > window.innerHeight && elemBottom > window.innerHeight;;
//     // Partially visible elements return true:
//     const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
//     return isVisible || isUnderViewport;
//   }

  hide() {
    this.classList.remove("sticky");
  }

  reveal() {
    this.classList.add("sticky");
  }
}

customElements.define("sticky-atc", StickyAtc);
